import { QueryConfig } from "store/utils/query-config";

export const articleCollectionDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"],
  },
};
